<template lang="pug">
  .package-box
    h3 {{item.name}}
    ul.attachments
      li(v-for="attachment in item.attachments")
        a(:href="attachment.pdf" target="_blank")
          span {{attachment.name}}
        p {{attachment.description}}
</template>

<script type="text/javascript">
export default {
  name: "Package",
  props: ["item"],
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
